import React from 'react'
import Container from '../../atoms/Container'
import Img from './../../molecules/Img';
import char from '../../../assets/pics/char/char.jpg'
import Title from './../../atoms/Title';
import frame2 from '../../../assets/pics/char/Frame2.png'
import frame3 from '../../../assets/pics/char/Frame3.png'
import frame4 from '../../../assets/pics/char/Frame4.png'
import frame5 from '../../../assets/pics/char/Frame5.png'
import Charcard from '../../molecules/Charcard';
import { useTranslation } from 'react-i18next';

const content =[
  {
    id:0,
    icon: frame2,
    title:"فنون شعبية"
  },
  {
    id:1,
    icon: frame3,
    title:"شخصية عامة "
  },

  {
    id:4,
    icon: frame5,
    title:"ش ابوداوود مدينة نصر محافظة القاهرة"
  },
]
export default function Charintro({data}) {
  // console.log("dattttttttta",data);
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const noData = t("common.noData");
  const field = (name) => {
    const value = isArabic ? data?.[name] : data?.[`${name}E`];
    return value != null && String(value).trim() !== "" ? value : noData;
  };

  return (
    // <div className='h-[812px] bg-rd-400 mt-20 mb-3 mx-1 md:mx-6 flex flex-row justify-between items-center' style={{ direction: "rtl" }}>
    <div className='h-fit bg-rd-400 mt-20 mb-3 mx-1 md:mx-6 flex flex-row justify-between items-stretch'>
      <div bgColor className='h-auto w-1/4 me-2 md:me-5 bg-red500 my-3'>
        <Container bgColor className='py-[20px] h-full flex flex-col justify-start items-center'>
        {/* <div className='mt-[20px] h-2/5 md:h-1/2 flex flex-col justify-start items-center'> */}
        <div className='h-fit flex flex-col justify-start items-center'>
           <div>
            <Img
              // src={char}
              src={data?.imgLink}
              alt={field("characterName")}
              char
            />
          </div>
          <div className='mt-[10px] bg-re-500'>
            <Title primary3>{field("characterName")}</Title>
          </div>
          
        </div>

        <div className='grid grid-cols-[1fr_3fr] gap-y-2 md:gap-y-3 bg-ed-200 h-fit mx-2 md:mx-4 mt-[40px]'>
            <div className='bg-yellw-400 flex items-center justify-center'>
              <Img
                 src={frame2}
                 alt={"fram2"}
                 charIcon
              />
            </div>
            <div className='text-start flex items-center bg-yelow-600 font-tajawal-regular text-xs md:text-lg'>
            {/* فنون شعبية  */}
            {field("fieldName")}
            </div>

            <div className='flex items-center justify-center'>
              <Img
                 src={frame3}
                 alt={"fram3"}
                 charIcon
              />
            </div>

            <div className='text-start flex items-center font-tajawal-regular text-xs md:text-lg'>
            {/* شخصية عامة  */}
            {field("specialityName")}
            </div>


            <div className='flex items-center justify-center'>
              <Img
                 src={frame4}
                 alt={"fram3"}
                 charIcon
              />
            </div>

            <div className='flex flex-col justify-center items-start font-tajawal-regular text-xs md:text-lg'>
               {/* <div>01 فبراير1938</div> */}
               <div>{field("birthDateFormatted")}</div>
               {/* <div>15 سبتمبر 2019</div> */}
               <div>{field("deathDateFormatted")}</div>
            </div>

            <div className='flex items-center justify-center'>
              <Img
                 src={frame5}
                 alt={"fram5"}
                 charIcon
              />
            </div>
            <div className='flex justify-start items-center text-start font-tajawal-regular text-xs md:text-lg'>
            {/* ش ابوداوود مدينة نصر محافظة القاهرة */}
                {field("characterAddress")}
              </div>


        </div>
         {data?.nameImage?
            <div className='mx-2 md:mx-4 mt-[40px]'>
            <div>
                <Img
                  // src={char}
                  src={data?.nameImage}
                  alt={field("characterName")}
                  char
                />
              </div>
            </div>
         :null}
        </Container>
      </div>


      <div className='w-3/4 bg-re-400 flex flex-col justify-between' style={{ alignSelf: 'stretch' }}>
        <Charcard 
            title={t("char.bio")}
            // content={`مصمم الاستعراضات Hassan Afify - تخرج "عفيفي" في كلية العلوم بجامعة القاهرة عام 1962، ورغم اهتمامه بالنشاط الفني بالجامعة، فإنه بدأ مشواره الفني من البطولات الرياضية التي شارك فيها، من خلال القفز بالزانة، وحصل على عدة ميداليات ذهبية خلال مشاركته في دورة ألعاب البحر الأبيض المتوسط، بالإضافة لبطولات دولية أخرى في اليونان وألمانيا. - انضم بعد ذلك إلى "فرقة رضا" عام 1965، ، وأثناء ذلك خاض تجربة التمثيل التي بدأت في فيلم "إجازة نص السنة"ضمن نجوم الفرقة. - نجاح تجربته التمثيلية الأولى دفعته لتكرارها مع فيلم "غرام في الكرنك"، الذي صور في الأقصر وأسوان، وكانت ذراعه مكسورة إثر سقوطه أثناء مسابقة القفز بالزانة، كما شارك في أفلام : "الحب سنة 70"، و"فتاة الاستعراض". - -`}
            content={field("bio")}
            primary3
            charIntro
          ></Charcard>
          <Charcard
            title={t("char.works")}
            // content={`بعد اعتزال الرقص؛ اتجه "عفيفي" لتصميم الرقصات، صمم حسن عفيفي استعراضات العديد من الأفلام السينمائية، مثل "نور العيون"، و"سيرة الحب"، و"عايشين للحب"، و"آدم والنساء". - بدأ رحلته مع الفوازير عام 1980، بتصميم استعراضات فوازير نيللي، مثل "عروستي"، و"الخاطبة"، و"عالم ورق ورق"، و"صندوق الدنيا"، و"الدنيا لعبة"، وأخيراً فوازير "زي النهاردة"، التي كانت آخر عمل جمعهما. - كما تعاون في تصميم استعراضات سمير غانم، في 3 فوازير، منها: "فطوطة"، و"المتزوجون في التاريخ".أما أول تعامل له مع شريهان، فكان خلال مسلسل "ألف ليلة وليلة"، ليقدما بعدها فوازير "حول العالم" عام 1987 كماتعاون أيضاً مع صابرين وهالة فؤاد ويحيى الفخراني، في تقديم فوازير "المناسبات"، ومع جيهان نصر في فوازير "الحلو ميكملش". - كما صمم استعراضات عدة مسلسلات تلفزيونية، من أبرزها "أحلام عادية"، و"ألف ليلة وليلة"، و"جحا المصري" - صمم أيضا استعراضات مسرحية "المدرسون والدروس الخصوصية "الجوكر" و"بهلول في إستانبول" وفيلم "نور العين" و"آه وآه من شربات `}
            content={field("works")}
            primary3
            charIntro

          />
      </div>
    </div>
  )
}
